import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

import { getAppConfig } from '../../lib/config';

const { entraClientId, entraTenantId, entraRedirectUri } = getAppConfig();

const msalConfig: Configuration = {
  auth: {
    clientId: entraClientId,
    authority: `https://login.microsoftonline.com/${entraTenantId}`,
    redirectUri: entraRedirectUri ?? window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const hubApiScope = `api://${entraClientId}/access_as_user`;

export const hubLoginRequest = {
  scopes: [hubApiScope],
};
